export default "__VITE_ASSET__311aef9a__"